module.exports = __webpack_public_path__ + "img/pay_bank_14.5dae887b.png";